// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';
import { Subscription, tap, throttleTime } from 'rxjs';
import { fromEmitter } from 'rxjs-from-emitter';
import type {
  CastReceiverContext,
  NetworkRequestInfo,
  PlaybackConfig,
} from '../../types/chromecast-caf-receiver/cast.framework';
import store, { SEGMENT_HOST } from '../../store';
import {
  customMessageAction,
  mediaFilter,
  overlayManagerFilter,
  playbackInfoHandlerFilter,
} from '../extensions';
import { PluginInterface } from './PluginInterface';
import { CAST_MESSAGES } from '../../config/receiver';
import { OverlayManager } from '../../overlays';
import { makeMediaObject } from '../../services/media';
import { stats } from '../../overlays/stats';
import cast from '../../types/chromecast-caf-receiver';
import { CustomCommands } from '../../types';

export class StatsPlugin implements PluginInterface {
  private context: CastReceiverContext;
  private subscription: Subscription | null;
  private overlayManager: OverlayManager;
  private media: ReturnType<typeof makeMediaObject>;

  private _overlayEnabled: boolean = false;
  get overlayEnabled(): boolean {
    return this._overlayEnabled;
  }

  set overlayEnabled(value: boolean) {
    if (value) {
      if (this.subscription == null) {
        const playerManager = this.context.getPlayerManager();
        const timeUpdate$ = fromEmitter(playerManager).event(
          cast.framework.events.EventType.TIME_UPDATE
        );
        this.subscription = timeUpdate$
          .pipe(
            throttleTime(1000),
            tap(() => {
              this.overlayManager.showOverlay(stats, {
                ...playerManager.getStats(),
                dynamicRange: this.media.dynamicRange,
              });
            })
          )
          .subscribe();
      }
    } else {
      this.overlayManager.hideOverlay();
      this.subscription?.unsubscribe();
      this.subscription = null;
    }
    this._overlayEnabled = value;
  }

  init(context: CastReceiverContext) {
    this.context = context;
    playbackInfoHandlerFilter.register(this.playbackInfoHandlerTransform.bind(this));

    customMessageAction.register(request => {
      const command = request.data.command as CustomCommands;
      if (command === 'DEBUG_OVERLAY') {
        this.overlayEnabled = !this.overlayEnabled;

        context.sendCustomMessage(CAST_MESSAGES.CUSTOM, request.senderId, {
          command,
          status: this.overlayEnabled ? 'enabled' : 'disabled',
        });
      }
    });

    overlayManagerFilter.register(async (overlayManager: OverlayManager) => {
      this.overlayManager = overlayManager;
      return overlayManager;
    });

    mediaFilter.register(async media => {
      this.media = media;
      return media;
    });
  }

  async playbackInfoHandlerTransform(playbackConfig: PlaybackConfig, loadRequest: LoadRequestData) {
    return {
      ...playbackConfig,
      segmentRequestHandler: (e: NetworkRequestInfo) => {
        if (!e.url) return;

        const segmentUrl = new URL(e.url);
        store.set(SEGMENT_HOST, segmentUrl.host);
      },
    };
  }
}
